import React from "react"
import ReactDOM from "react-dom"

const ReactRailsUJS = {
  findDOMNodes() {
    return document.querySelectorAll("[data-react-class]")
  },

  mountComponents() {
    this.findDOMNodes().forEach(node => {
      const componentLocation = node.getAttribute("data-react-class").split(".")
      const propsJSON = node.getAttribute("data-react-props")
      const props = propsJSON ? JSON.parse(propsJSON) : {}

      const componentPath = componentLocation.slice(0, -1).reduce((acc, part) => acc[part], window)
      const componentName = componentLocation[componentLocation.length - 1]
      const Component = componentPath[componentName]

      if (Component) {
        ReactDOM.render(React.createElement(Component, props), node)
      } else {
        console.error(`Component "${componentName}" not found in registry`)
      }
    })
  },

  unmountComponents() {
    this.findDOMNodes().forEach(node => {
      ReactDOM.unmountComponentAtNode(node);
    })
  },

  setupEvents() {
    document.addEventListener("DOMContentLoaded", () => {
      this.mountComponents()
    })
  }
}

ReactRailsUJS.setupEvents()

export default ReactRailsUJS
